import {
  resolveExecute,
} from './partialUpdate';
import { isTextField } from '../lib/dom';

const events = [
  'add',
  'blur',
  'change',
  'input',
  'click',
  'debounce',
  'focus',
  'keydown',
  'keyup',
  'select',
  'submit',
  'selectionChange', // grid v Edee
  'uploadcomplete', // upload button
];

let values = {};

const handlePartialUpdateEvent = (event) => {
  // nereagovat na eventy z input elementů, které nemají definovaný name attribut
  // ponejvíce se jedná jen o pomocné inputy, které mohou firovat event v nežádoucí době
  if (event.target && event.target.tagName === 'INPUT' && (event.target.getAttribute('name') == null || event.target.getAttribute('name') === '')) {
    return;
  }
  const { $ } = window;
  const isJQEvent = $ && event instanceof $.Event;
  const target = isJQEvent ? event.currentTarget : event.target;
  resolveExecute(target);
};

const debounceTimers = {};

const handleChangeEvent = (event) => {
  event.preventDefault();
  const { $ } = window;
  const isJQEvent = $ && event instanceof $.Event;
  let target = isJQEvent ? event.currentTarget : event.target;
  const isDebounced = (
    target.getAttribute('data-pu') || target.getAttribute('data-partial-update')
  ) === 'debounce';
  if (isDebounced) {
    // https://stackoverflow.com/questions/44831556/why-does-e-currenttarget-change-with-jquerys-event-delegation
    // z toho důvodu se udělá clone eventu
    if (isJQEvent) {
      event = { ...event };
      target = event.currentTarget;
    }

    const id = target.getAttribute('id');
    clearTimeout(debounceTimers[id]);
    // TODO mezi timeoutem a dalším vyvoláním PU abortnout související PU
    debounceTimers[id] = setTimeout(() => {
      clearTimeout(debounceTimers[id]);
      delete debounceTimers[id];
      handlePartialUpdateEvent(event);
    }, 300);
  } else {
    handlePartialUpdateEvent(event);
  }
};

const handleOtherEvent = (event) => {
  event.preventDefault();
  handlePartialUpdateEvent(event);
};

/**
 * Nastaví listenery na data-partial-update attributy v documentu.
 * PU bude reagovat na event, který je definován v data-partial-update atributu
 * Automaticky naslouchá na tyto eventy
 * <em>'add','blur','change','click','debounce','focus','keydown','keyup','select','submit','selectionChange','uploadcomplete'</em>
 * Další eventy je nutno definovat parametru customEvents
 * @param customEvents
 */
export const partialUpdateConnectDatasetListeners = (customEvents) => {
  const allEvents = [...events, ...customEvents];
  const indexOfDebounce = allEvents.indexOf('debounce');
  const { $ } = window;
  const reducedEvents = [...allEvents];
  if (indexOfDebounce !== -1) {
    reducedEvents.splice(indexOfDebounce, 1);
  }
  reducedEvents.forEach((eventForDelegation) => {
    let selector = `[data-pu="${eventForDelegation}"], [data-partial-update="${eventForDelegation}"]`;
    if (eventForDelegation === 'change') {
      if (indexOfDebounce !== -1) {
        selector = `${selector}, [data-pu="debounce"], [data-partial-update="debounce"]`;
      }
      document.addEventListener('change', (e) => {
        const closest = e.target.closest(selector);
        // change event target to closest
        if (closest) {
          let canHandle = true;

          // prevent change event při bluru na textových polích
          // change PU se provede jen v případě, že se změní hodnota
          // https://ep.fg.cz/issues/83732
          if (isTextField(e.target)) {
            const id = closest.getAttribute('id');
            const lastValue = values[id];
            const actValue = closest.value;
            canHandle = actValue !== lastValue;
            values[id] = actValue;
          }

          Object.defineProperty(e, 'target', {
            value: closest,
            writable: false,
          });
          if (canHandle) {
            handleChangeEvent(e);
          }
        }
      });

      if ($ && $.fn) {
        $(document).on('change', selector, (e) => {
          const isJQEvent = e instanceof $.Event;
          // reagovat jen na jQuery eventy v opačném případě je event odchycen nativním listenerem
          // https://ep.fg.cz/issues/89448
          if (isJQEvent && e.originalEvent == null) {
            let canHandle = true;
            // prevent change event při bluru na textových polích
            // change PU se provede jen v případě, že se změní hodnota
            // https://ep.fg.cz/issues/83732
            if (isTextField(e.target)) {
              const id = e.target.getAttribute('id');
              const lastValue = values[id];
              const actValue = e.target.value;
              canHandle = actValue !== lastValue;
              values[id] = actValue;
            }

            if (canHandle) {
              handleChangeEvent(e);
            }
          }
        });
      }
    } else {
      document.addEventListener(eventForDelegation, (e) => {
        // FF throw error
        if (e.target === document) {
          return;
        }
        const closest = e.target.closest(selector);
        if (closest) {
          // change event target to closest
          Object.defineProperty(e, 'target', {
            value: closest,
            writable: false,
          });
          handleOtherEvent(e);
        }
      });
      if ($ && $.fn) {
        $(document).on(eventForDelegation, selector, (e) => {
          const isJQEvent = e instanceof $.Event;
          if (isJQEvent && e.originalEvent == null) {
            handleOtherEvent(e);
          }
        });
      }
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/eventsFromDOMDatasetsRegister.js